import { z } from "zod";
import { DealStage, DealPriority, DealStatus, DealLostReason, LeadSource } from "../api/crmApi";

export const dealSchema = z
    .object({
        title: z
            .string()
            .min(1, "Title is required")
            .max(200, "Title must be less than 200 characters"),
        description: z
            .string()
            .max(500, "Description must be less than 500 characters")
            .optional(),
        dealValue: z.number().min(0, "Value must be 0 or greater"),
        expectedCloseDate: z.string().optional(),
        actualCloseDate: z.string().optional(),
        probability: z.number().min(0).max(100).optional(),
        companyId: z.string().min(1, "Company is required"),
        contactId: z.string().optional(),
        assignedTo: z.string().min(1, "Assignee is required"),
        stage: z.nativeEnum(DealStage, { errorMap: () => ({ message: "Stage is required" }) }),
        priority: z.nativeEnum(DealPriority, {
            errorMap: () => ({ message: "Priority is required" }),
        }),
        status: z.nativeEnum(DealStatus).optional(),
        lostReason: z.nativeEnum(DealLostReason).optional(),
        source: z.nativeEnum(LeadSource).optional(),
    })
    .superRefine((data, ctx) => {
        if (data.status === DealStatus.LOST && !data.lostReason) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Lost reason is required when status is Lost",
                path: ["lostReason"],
            });
        }
    });

export type DealFormValues = z.infer<typeof dealSchema>;
